import {
    ChangeDetectionStrategy,
    Component,
    computed,
    ElementRef,
    inject,
    input,
    InputSignal,
    viewChild,
} from '@angular/core';

import { LayerAttribute } from '@connect-services/client/sdk/api';
import { DetailPanelService } from '@connect-services/client/services/detail-panel.service';

const WIDTH_PX_BREAKPOINT = 700;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    selector: 'app-layer-data-attributes-list',
    styleUrl: './layer-data-attributes-list.component.scss',
    templateUrl: './layer-data-attributes-list.component.html',
})
export class LayerDataAttributesListComponent {
    public readonly dataAttributes: InputSignal<LayerAttribute[]> = input.required();

    protected readonly isWide = computed(
        () =>
            this.detailPanelService.expandedVertically() &&
            this.width().nativeElement.offsetWidth > WIDTH_PX_BREAKPOINT,
    );
    protected readonly width = viewChild.required<ElementRef<HTMLInputElement>>('attributesDiv');

    private readonly detailPanelService = inject(DetailPanelService);
}
